<template>
  <div class="water-tracking-widget">
    <div style="height:450px !important;" class="panel panel-default card-view">
      <div class="panel-heading">
        <div class="pull-left">
          <h6 class="panel-title txt-light">My Water Intake</h6>
        </div>
        <div class="pull-right">
          <!-- <a href="#" class="pull-left inline-block mr-15" @click="showWaterIntakeRecords = !showWaterIntakeRecords">
						<i class="zmdi zmdi-eye"></i>
          </a>-->
        </div>
        <div class="clearfix"></div>
      </div>
      <div id="collapse_1" class="panel-wrapper collapse in">
        <div class="panel-body">
          <div class="loader" v-show="loading"></div>
          <div id="water-status" v-show="!showWaterIntakeRecords" class="animated fadeIn text-center">
            <img src="https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/glass.png" alt="" style="height: 230px;">
            <!-- <div id="cup">
              <h1>
                <span id="consumed_percentage">0</span>%
              </h1>
              <div id="water"></div>
            </div> -->
            <h6>Target water intake: {{recommended_water_intake}} {{current_liquid_units}} ({{percentage_consumed}}%)</h6>
            <p>Consumed today: {{amount_consumed}} {{current_liquid_units}}</p>
            <div style="padding-top:10px;" class="col-sm-12">
              <div class="col-sm-12 mb-20">
                <a
                  href="#"
                  class="btn btn-nutri-orange full-width"
                  @click="addWater(200)"
                  style="padding:10px; font-size:10px;"
                >+ 1 Cup
                  <br>
                  <small>({{current_liquid_units == "litres" ? "200ml" : "6.7oz"}})</small>
                </a>
              </div>
              <!-- <div class="col-sm-4 mb-20">
                <a
                  href="#"
                  class="btn btn-nutri-green full-width"
                  @click="addWater(400)"
                  style="padding:10px; font-size:10px;"
                >+ 2 Cups
                  <br>
                  <small>({{current_liquid_units == "litres" ? "400ml" : "13.5oz"}})</small>
                </a>
              </div>
              <div class="col-sm-4 mb-20">
                <a
                  href="#"
                  class="btn btn-nutri-green full-width"
                  @click="addWater(1000)"
                  style="padding:10px; font-size:10px;"
                >+ 4 Cups
                  <br>
                  <small>({{current_liquid_units == "litres" ? "1000ml" : "33.8oz"}})</small>
                </a>
              </div> -->
            </div>
          </div>
          <!-- <div id="water-records" v-show="showWaterIntakeRecords" class="animated fadeIn">
						<h5 class="mb-20">Water Intake Records</h5>
						<div class="table-wrap">
							<div class="table-responsive">
								<table class="table table-hover mb-0">
									<tbody>
										<tr v-for="(record, key) in water_intake_records" :key="key">
											<td>{{convertLiquid(record.number_of_milliliters)}} {{current_liquid_units}}</td>
											<td class="text-right">{{new Date(record.created_at).getHours()}}:{{new Date(record.created_at).getMinutes() < 10 ? '0' + new Date(record.created_at).getMinutes() : new Date(record.created_at).getMinutes()}}</td>
											<td class="text-right" style="width:10%">
												<a href="#" class="trash" title="Delete" @click="deleteRecord(record.id)">
													<i class="fa fa-trash"></i>
												</a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div v-if="show" style="height:600px !important;overflow-x:auto;" class="panel panel-default card-view">
			<div class="panel-heading">
				<div class="pull-left">
					<h6 class="panel-title txt-light">Water Intake Records</h6>
				</div>
				<div class="clearfix"></div>
			</div>
			<div style="padding-bottom:10px;" id="collapse_1" class="panel-wrapper collapse in">
				<p v-if="water_intake_records.length == 0" style="padding-top:10px">There are no records to show.</p>
				<div id="water-records" class="animated fadeIn">
					<div class="table-wrap">
						<div class="table-responsive">
							<table style="" class="table table-hover mb-0">
								<tbody>
									<tr v-for="(record, key) in water_intake_records" :key="key">
										<td class="table-item">{{convertLiquid(record.number_of_milliliters)}} {{current_liquid_units}}</td>
										<td class="text-right table-item">{{new Date(record.created_at).getHours()}}:{{new Date(record.created_at).getMinutes() < 10 ? '0' + new Date(record.created_at).getMinutes() : new Date(record.created_at).getMinutes()}}</td>
										<td class="text-right table-item" style="width:10%">
											<a href="#" class="trash" title="Delete" data-toggle="modal" @click="temp_id = record.id" data-target="#exampleModal">
												<i class="fa fa-trash"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
					</div>
					<div class="modal-body">
						Are you sure you want to delete this water record?
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
						<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="deleteRecord(temp_id)">Okay</button>
					</div>
					</div>
				</div>
			</div>
		</div>
    <loading :active.sync="isLoading"></loading>
	</div>
</template>

<script>
import API from "../../services/api.js";
import { mapMutations } from "vuex";
const api = new API();
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    swal,
    Loading,
  },
  props: ["date"],
  data() {
    return {
      isLoading: false,
      temp_id: 0,
      current_liquid_units:
        this.$store.getters.user.meta_data.preferred_units == "metric"
          ? "litres"
          : "ounces",
      recommended_water_intake: this.$store.getters.user
        .recommended_water_intake,
      amount_consumed: 0,
      percentage_consumed: 0,
      loading: false,
      water_intake_records: [],
      showWaterIntakeRecords: false,
      show: true,
    };
  },
  created() {
    if(this.$route.path == '/dashboard'){
      this.show = false
    }
    this.getWaterIntake();
  },
  methods: {
    deleteRecord(id) {
      this.isLoading = true;
      api.deleteWaterIntake(id).then(response => {
        if (response.data.success) {
          this.isLoading = false;
          this.getWaterIntake();
        } else {
        }
      });
    },
    convertLiquid(ml) {
      if (this.$store.getters.user.meta_data.preferred_units == "metric") {
        return ml / 1000;
      } else {
        return ml * 0.033814;
      }
    },
    addWater(ml) {
      this.isLoading = true;
      api.addWaterIntake(ml, this.$store.getters.globalDate).then(response => {
        if (response.data.success) {
          this.isLoading = false;
          this.getWaterIntake();
          //swal("Water Tracked!", "", "success");
        } else {
        }
      });
    },
    getWaterIntake() {
      this.loading = true;
      api.getWaterIntake(new Date(this.date)).then(response => {
        if (response.data.success) {
          this.loading = false;
          this.amount_consumed = parseFloat(
            response.data.data.totals.water_intake
          ).toFixed(2);
          this.percentage_consumed = parseFloat(
            (this.amount_consumed / this.recommended_water_intake) * 100
          ).toFixed(0);
          this.moveWater(this.percentage_consumed);
          this.water_intake_records = response.data.data.water_intake_records;
        } else {
        }
      });
    },
    moveWater(newHeight) {
      var extraHeight;
      if (newHeight > 100) {
        extraHeight = newHeight - 100;
        newHeight = 100;
      }
      var elem = $("#water");
      var height = Math.round((elem.height() / elem.parent().height()) * 100);
      var id = setInterval(frame, 10);

      function frame() {
        if (height < newHeight) {
          height++;
          elem.css("height", height + "%");
          $("#consumed_percentage").text(height);
        } else if (height > newHeight) {
          height--;
          elem.css("height", height + "%");
          $("#consumed_percentage").text(height);
        } else {
          clearInterval(id);
        }
      }
    }
  },
  watch: {
    date: function() {
      this.getWaterIntake();
    }
  }
};
</script>

<style scoped>
small{
  color:white;
}

.trash {
  color: rgba(204, 0, 0, 0.5);
}

.trash:hover {
  color: rgba(204, 0, 0, 1);
}

.table-item {
  border-top: 0px !important;
  border-bottom: 1px solid;
}

#cup {
  border: 6px solid #555;
  width: 150px;
  height: 150px;
  position: relative;
  border-radius: 10px;
  border-top: none;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  margin: 30px auto;
  border-top: 2px solid #666;
}

#cup h1 {
  text-align: center;
  margin-top: 30%;
  position: relative;
  z-index: 999;
  font-weight: lighter;
}

#water {
  background: #8bcaf1;
  width: 100%;
  height: 0;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  color: #fff;
  font-weight: bold;
  font-size: 100%;
  text-align: center;
}

h6,
p {
  text-align: center;
}

.loader {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  text-align: center;
  padding-top: 20%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/WaterTracker.vue